import React from "react";

export default function DocsDetails() {
  return <div>DocsDetails</div>;
}
